/* This file is autogenerated, see readme.md for instructions */
import UsersSvgIcon from '@bloomreach/banana-theme/icons/users.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UsersIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UsersSvgIcon />
    </Icon>
  );
});

UsersIcon.displayName = 'UsersIcon';

export default UsersIcon;
